const isAcquisitionImage = (image) => image?.origin === 'acquisition';

export { isAcquisitionImage };
